export const ROW_ACTIONS = {
  DETALLE_RECIBO: "DETALLE_RECIBO",
  ANULAR_RECIBO: "ANULAR_RECIBO",
  DESAPLICAR_RECIBO: "DESAPLICAR_RECIBO",
  VER_FACTURA: "VER_FACTURA",
  DETALLE_FACTURA: "DETALLE_FACTURA",
  ANULAR_FACTURA: "ANULAR_FACTURA",
  ENVIAR_POR_MAIL: "ENVIAR_POR_MAIL",
};
